module.exports = __webpack_public_path__ + "static/media/0030_IMG_LE_SOL_CARRELAGE_EXISTANT.385efaa5.png";